import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from 'services/api';

function saApi() {
  return { headers: { Authorization: `Bearer ${localStorage.getItem('gss_sa_token')}` } };
}

// ⚠️ LES CODES SONT DESORMAIS CEUX DE LA GRILLE. Avant le 03/09/2026, l'ecran
//    portait les anciens codes techniques (starter/business/enterprise) et les
//    RE-ETIQUETAIT en ALPHA/VANGUARD/ELITE : trois vocabulaires pour une notion,
//    dont aucun ne correspondait a la grille en base. Les anciens codes restent
//    ici pour afficher correctement une donnee non encore migree.
const OFFRE_COLORS = {
  alpha: 'var(--gss-success)', vanguard: 'var(--gss-info)', elite: 'var(--gss-red)',
  elite_plus: 'var(--gss-warning)',
  starter: 'var(--gss-success)', business: 'var(--gss-info)', enterprise: 'var(--gss-red)',
};
const OFFRE_LABELS = {
  alpha: 'ALPHA', vanguard: 'VANGUARD', elite: 'ELITE', elite_plus: 'ELITE+',
  starter: 'ALPHA', business: 'VANGUARD', enterprise: 'ELITE',
};
const STATUT_COLORS = { actif: 'var(--gss-success)', suspendu: 'var(--gss-danger)', essai: 'var(--gss-warning)' };

// ⚠️ LA LISTE DES PAYS VIENT DU REFERENTIEL, plus d'un tableau en dur.
//    L'ancienne liste portait 15 pays sur 19 (ni Ghana, ni Nigeria, ni Guinee
//    equatoriale, ni Guinee-Bissau) ET des noms SANS ACCENTS (« Cote d'Ivoire »,
//    « Benin », « Senegal ») : une SECONDE SOURCE pour une notion, qui divergeait
//    de la base des le premier renommage. Retiree le 03/09/2026.

const MODULES_LIST = [
  { code: 'tsv', label: 'TSV (Telesurveillance)' },
  { code: 'cynophile', label: 'Cynophile' },
  // ⓘ `escorte_protocole` retire le 03/09/2026 : aucune table, aucun ecran,
  //    aucune route. Offre A VENIR dans la grille, pas un module activable.
  { code: 'formation', label: 'Formation' },
  { code: 'audit_deploiement', label: 'Audit & Deploiement' },
  { code: 'app_mobile', label: 'App Mobile (Phase 7)' },
  { code: 'api', label: 'API' },
];

const EMPTY_FORM = {
  // `nom` = denomination d'USAGE · `raison_sociale` = denomination LEGALE,
  // celle que portent les documents juridiques (colonne NOT NULL).
  nom: '', raison_sociale: '', email_admin: '', offre: 'alpha',
  dirigeant: '', rccm: '', nif: '', adresse: '', ville: '', telephone: '', prefixe_matricule: '',
  pays: 'Togo', modules: [],
};

// La RUE ne doit pas re-contenir la ville ni le pays : ce sont des champs
// SEPARES que les generateurs ajoutent ensuite (adresse + ', ' + ville + ' - ' + pays).
// Miroir de backend/src/utils/adresse.js — le backend fait foi, ceci est pour l'UX.
const norm = (v) => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().replace(/\s+/g, ' ').trim();
function erreurRue(rue, ville, pays) {
  const r = norm(rue); if (!r) return null;
  const v = norm(ville), p = norm(pays);
  const segments = r.split(',').map(x => x.trim()).filter(Boolean);
  const accoles = (v && p) ? [`${v}-${p}`, `${v} - ${p}`, `${v} ${p}`] : [];
  for (const seg of segments) {
    if (v && seg === v) return `Retirez la ville ("${ville}") de la rue : elle a son propre champ.`;
    if (p && seg === p) return `Retirez le pays ("${pays}") de la rue : il a son propre champ.`;
    if (accoles.includes(seg)) return `Retirez "${ville}-${pays}" de la rue : ville et pays ont leurs propres champs.`;
  }
  return null;
}

export default function SuperAdminTenants() {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ ...EMPTY_FORM });
  const [editId, setEditId] = useState(null);
  const [editComptes, setEditComptes] = useState([]);
  const [editForm, setEditForm] = useState(null);
  const [saving, setSaving] = useState(false);
  // ⚠️ LES OFFRES SONT LUES DANS LA GRILLE, jamais ecrites dans l'ecran.
  //    En cas d'echec, la liste reste VIDE et le formulaire le dit : aucune
  //    offre de secours n'est fabriquee cote client.
  const [offres, setOffres] = useState([]);
  const [erreurCreation, setErreurCreation] = useState(null);
  // Les pays proposables, lus dans le referentiel. En cas d'echec la liste
  // reste VIDE et le formulaire le dit : aucun pays de secours n'est invente.
  const [paysListe, setPaysListe] = useState([]);

  const load = () => {
    api.get('/super-admin/tenants', saApi()).then(r => setTenants(r.data))
      .catch(() => {}).finally(() => setLoading(false));
    api.get('/super-admin/tarifs', saApi())
      .then(r => setOffres((r.data || []).filter(x => x.categorie === 'offre')))
      .catch(() => setOffres([]));
    // ⚠️ La liste de creation ne propose QUE 'servi' et 'cadre_pose'
    //    (migration 021). On ne RETIRE aucun pays du referentiel — on ne
    //    PROPOSE pas ceux qu'on ne couvre pas. Le backend refuse de toute
    //    facon, en nommant la raison : l'ecran evite juste le clic inutile.
    api.get('/super-admin/referentiel-pays', saApi())
      .then(r => setPaysListe((r.data.pays || []).filter(p => p.actif)))
      .catch(() => setPaysListe([]));
  };
  useEffect(load, []);

  /* ⚠️ L'ERREUR DE CREATION NE PASSE PLUS PAR `alert()` (corrige le 03/09/2026).
   *    Le backend renvoie depuis le 02/09 un `lien` vers /super-admin/referentiel-pays
   *    et la liste `pays_disponibles` — DEUX CHAMPS QUE L'ECRAN JETAIT.
   *    Un `alert()` ne peut porter NI lien cliquable NI liste : il transformait
   *    une erreur actionnable (« va parametrer ce pays, voici ou ») en cul-de-sac.
   *    ⓘ Et il bloque le navigateur, ce que ce projet s'interdit par ailleurs. */
  const submit = async (e) => {
    e.preventDefault();
    setErreurCreation(null);
    try {
      await api.post('/super-admin/tenants', form, saApi());
      setShowModal(false);
      setForm({ ...EMPTY_FORM });
      load();
    } catch (err) {
      const d = err.response?.data || {};
      setErreurCreation({
        message: d.error || 'La creation a echoue.',
        code: d.code || null,
        lien: d.lien || null,
        pays_disponibles: Array.isArray(d.pays_disponibles) ? d.pays_disponibles : [],
      });
    }
  };

  /* ⚠️ TROIS ETATS, PAS DEUX. La route accepte `actif | essai | suspendu`
   *    depuis l'origine ; l'ecran n'en offrait que deux et basculait de l'un a
   *    l'autre. Un etat qui existe en base sans chemin pour y arriver, c'est le
   *    defaut deja corrige deux fois sur ce projet.
   * ⚠️ LE MOTIF EST OBLIGATOIRE POUR SUSPENDRE. Une suspension sans raison ne
   *    se relit pas trois mois plus tard. */
  const changerStatut = async (t, nouveau) => {
    if (nouveau === t.abo_statut) return;
    let motif = null;
    if (nouveau === 'suspendu') {
      motif = window.prompt(
        `Suspendre « ${t.nom} » ?\n\n`
        + 'Ses utilisateurs pourront toujours se connecter et CONSULTER leurs donnees,\n'
        + 'mais ne pourront plus rien creer ni modifier. Aucune donnee n\'est supprimee.\n\n'
        + 'Motif de la suspension (obligatoire) :'
      );
      if (motif === null) return;                 // annulation
      if (motif.trim().length < 3) { alert('Le motif est obligatoire.'); return; }
    }
    try {
      await api.patch(`/super-admin/tenants/${t.id}/statut`, { statut: nouveau, motif }, saApi());
      load();
    } catch (err) {
      alert(err.response?.data?.error || 'Erreur lors du changement de statut');
    }
  };

  const openEdit = (t) => {
    const c = t.config || {};
    setEditId(t.id);
    setEditComptes(Array.isArray(t.comptes) ? t.comptes : []);
    setEditForm({
      nom: t.nom || '', raison_sociale: t.raison_sociale || '', dirigeant: t.dirigeant || '',
      rccm: t.rccm || '', nif: t.nif || '',
      adresse: t.adresse || '', ville: t.ville || '', telephone: t.telephone || '',
      prefixe_matricule: t.prefixe_matricule || '', pays: t.pays || 'Togo',
      niveau_support: t.niveau_support || 'standard',
      modules: Array.isArray(t.modules) ? t.modules : [],
      forme_juridique: c.forme_juridique || '',
      secteur: c.secteur || '',
      cnss: c.cnss || '',
      regime_fiscal: c.regime_fiscal || '',
      agrement_securite: c.agrement_securite || '',
      email_societe: t.email_societe || c.email || '',
      capital_social: c.capital_social || '',
    });
  };

  const saveEdit = async () => {
    setSaving(true);
    try {
      await api.put(`/super-admin/tenants/${editId}`, editForm, saApi());
      setEditId(null); setEditForm(null);
      load();
    } catch (err) { alert(err.response?.data?.error || 'Erreur'); }
    finally { setSaving(false); }
  };

  /* ═══════════════════════════════════════════════════════════════════════
   * PAIEMENT ANNUEL — LE CHEMIN D'ECRITURE (051, 13/09/2026)
   * ═══════════════════════════════════════════════════════════════════════
   * ⚠️ POURQUOI CET ECRAN EXISTE. La colonne du rythme de paiement etait deja
   *    en base, lue et affichee — et ECRITE PAR PERSONNE. Trois clients en
   *    production portaient « mensuel » par defaut, jamais par decision. Une
   *    colonne sans chemin d'ecriture affiche une valeur que personne n'a
   *    choisie : c'est le defaut que ce lot ferme, pas celui qu'il ouvre.
   * ⚠️ LE RENOUVELLEMENT EST UN ACTE HUMAIN. Il recalcule le socle, donc il
   *    fixe ce que le client paiera douze mois. L'ordonnanceur, lui, refuse et
   *    alerte (regle 41 : le systeme ne decide jamais d'une valeur qui engage).
   * ⚠️ L'ECRAN MONTRE LA DERIVATION, PAS SEULEMENT LE MONTANT : effectif, prix
   *    unitaire et modules retenus. Un socle nu ne se rejoue pas (regle 6). */
  const [paiementId, setPaiementId] = useState(null);
  const [paiement, setPaiement] = useState(null);
  const [paiementErr, setPaiementErr] = useState(null);

  const ouvrirPaiement = async (t) => {
    setPaiementId(t.id); setPaiement(null); setPaiementErr(null);
    try {
      const r = await api.get(`/super-admin/tenants/${t.id}/paiement-annuel`, saApi());
      setPaiement(r.data);
    } catch (err) {
      setPaiementErr(err.response?.data?.error || 'Etat du paiement illisible');
    }
  };

  const rafraichirPaiement = async (id) => {
    const r = await api.get(`/super-admin/tenants/${id}/paiement-annuel`, saApi());
    setPaiement(r.data);
    load();
  };

  const basculerRythme = async (rythme) => {
    const nom = paiement?.tenant || 'ce client';
    if (rythme === 'annuel') {
      const socle = paiement?.calcul_du_jour?.montant;
      if (!socle) { alert('Le socle ne peut pas etre calcule : voir le refus affiche.'); return; }
      const ok = window.confirm(
        `Passer « ${nom} » en paiement annuel ?\n\n`
        + `Socle mensuel calcule aujourd'hui : ${Number(socle).toLocaleString('fr-FR')} F\n`
        + `Redevance emise immediatement : ${Number(socle * 10).toLocaleString('fr-FR')} F `
        + '(10 mois regles, 12 mois couverts)\n\n'
        + 'Les mois suivants, seul le depassement du socle sera appele.\n'
        + 'Une baisse d\'effectif ne donne lieu a aucun remboursement.'
      );
      if (!ok) return;
    } else {
      const ok = window.confirm(
        `Repasser « ${nom} » en paiement mensuel ?\n\n`
        + 'Le socle est efface et les mois suivants seront factures en entier.'
      );
      if (!ok) return;
    }
    try {
      await api.put(`/super-admin/tenants/${paiementId}/rythme-paiement`, { rythme }, saApi());
      await rafraichirPaiement(paiementId);
    } catch (err) {
      alert(err.response?.data?.error || 'Erreur lors du changement de rythme');
    }
  };

  const renouvelerSocle = async () => {
    const nom = paiement?.tenant || 'ce client';
    const nouveau = paiement?.calcul_du_jour?.montant;
    const ancien = paiement?.socle?.montant;
    if (!nouveau) { alert('Le nouveau socle ne peut pas etre calcule : voir le refus affiche.'); return; }
    const ok = window.confirm(
      `Renouveler le socle de « ${nom} » pour douze mois ?\n\n`
      + `Ancien socle : ${Number(ancien || 0).toLocaleString('fr-FR')} F/mois\n`
      + `Nouveau socle, sur l'effectif et les modules d'aujourd'hui : `
      + `${Number(nouveau).toLocaleString('fr-FR')} F/mois\n`
      + `Redevance emise : ${Number(nouveau * 10).toLocaleString('fr-FR')} F\n\n`
      + 'Le socle est recalcule, jamais reconduit a l\'identique.'
    );
    if (!ok) return;
    try {
      await api.post(`/super-admin/tenants/${paiementId}/renouveler-socle`, {}, saApi());
      await rafraichirPaiement(paiementId);
    } catch (err) {
      alert(err.response?.data?.error || 'Erreur lors du renouvellement');
    }
  };

  const toggleModule = (list, setList, code) => {
    const arr = Array.isArray(list) ? list : [];
    if (arr.includes(code)) setList(arr.filter(m => m !== code));
    else setList([...arr, code]);
  };

  return (
    <div style={S.page}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <Link to="/super-admin" style={{ color: 'var(--gss-text-light)', fontSize: 12, textDecoration: 'none' }}>Dashboard</Link>
          <span style={{ color: 'var(--gss-text-light)', margin: '0 8px' }}>/</span>
          <span style={{ color: 'var(--gss-text)', fontSize: 14, fontWeight: 700 }}>Gestion des tenants</span>
        </div>
        <button onClick={() => setShowModal(true)} style={S.btn}>+ Nouveau tenant</button>
      </div>

      <div style={S.card}>
        <div className="gss-table-wrap">
        <table style={{ width: '100%', minWidth: 800, borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['Societe','Code','Offre','Agents','Revenu/mois','Statut','Date creation','Actions'].map(h =>
              <th key={h} style={S.th}>{h}</th>
            )}</tr>
          </thead>
          <tbody>
            {tenants.map(t => (
              <tr key={t.id}>
                <td style={S.td}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ color: 'var(--gss-text)', fontWeight: 600 }}>{t.nom}</span>
                    {t.tenant_interne && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 800, background: 'var(--gss-red-glow)', color: 'var(--gss-red)', letterSpacing: 1 }}>INTERNE</span>}
                  </div>
                  {/* `email_contact` = email de CONTACT DE LA SOCIETE, PAS un compte.
                      Sans ce libelle on le lit comme « le compte admin du tenant » —
                      c'est ce qui a fait chercher un compte inexistant le 21/08/2026. */}
                  <div style={{ color: 'var(--gss-text-light)', fontSize: 11 }}>
                    <span style={{ opacity: 0.65 }}>Contact societe :</span> {t.email_contact || '-'}
                  </div>
                  {(!t.comptes || t.comptes.length === 0) && (
                    <div style={S.pastilleAucunCompte}>aucun compte utilisateur</div>
                  )}
                </td>
                <td style={{ ...S.td, color: 'var(--gss-red)', fontWeight: 700, fontSize: 12 }}>{t.prefixe_matricule || '-'}</td>
                <td style={S.td}>
                  <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                    color: OFFRE_COLORS[t.offre] || 'var(--gss-text-light)',
                    textTransform: 'uppercase' }}>
                    {/* ⚠️ Une offre absente chez l'EDITEUR est une decision, pas un
                        oubli : il ne se facture pas lui-meme. On le DIT, on ne laisse
                        pas un tiret qui ressemble a une donnee manquante. */}
                    {OFFRE_LABELS[t.offre] || t.offre || (t.est_editeur ? '— editeur' : '-')}
                  </span>
                </td>
                <td style={{ ...S.td, color: 'var(--gss-text)', fontWeight: 700 }}>{t.agents_actifs || 0}</td>
                <td style={{ ...S.td, color: 'var(--gss-red)', fontWeight: 700 }}>{Number(t.mrr_calcule || 0).toLocaleString()} F</td>
                {/* ⚠️ L'ETAT REEL, JAMAIS UN ETAT SUPPOSE. Avant le 02/09, cette
                    pastille affichait « suspendu » en rouge sur un tenant qui
                    fonctionnait pleinement : le statut n'etait lu par personne.
                    ⚠️ ABSENCE D'ABONNEMENT = ACTIF + ALERTE — et l'ecran le DIT,
                    au lieu d'afficher « non configure » sans conséquence lisible. */}
                <td style={S.td}>
                  {t.abo_statut ? (
                    <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                      color: STATUT_COLORS[t.abo_statut] || 'var(--gss-text-light)',
                    }}>{t.abo_statut}</span>
                  ) : (
                    <span title="Aucun abonnement enregistre : le client reste ACTIF, mais cela vous est signale."
                      style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                        color: 'var(--gss-warning)' }}>
                      actif · abonnement absent
                    </span>
                  )}
                </td>
                <td style={{ ...S.td, color: 'var(--gss-text-light)', fontSize: 12 }}>{new Date(t.created_at).toLocaleDateString('fr-FR')}</td>
                <td style={S.td}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => openEdit(t)} style={{
                      padding: '4px 12px', borderRadius: 6, border: '1px solid var(--gss-border-strong)', background: 'transparent',
                      color: 'var(--gss-red)', fontSize: 11, cursor: 'pointer',
                    }}>Fiche</button>
                    {/* ⚠️ LE RYTHME SE VOIT DANS LA LISTE, il ne se devine pas en
                        ouvrant un panneau. Un client annuel et un client mensuel
                        ne se facturent pas pareil : la difference doit etre
                        lisible la ou on regarde les clients. */}
                    <button onClick={() => ouvrirPaiement(t)} style={{
                      padding: '4px 12px', borderRadius: 6,
                      border: `1px solid ${t.rythme_paiement === 'annuel' ? 'var(--gss-success)' : 'var(--gss-border-strong)'}`,
                      background: 'transparent',
                      color: t.rythme_paiement === 'annuel' ? 'var(--gss-success)' : 'var(--gss-text-light)',
                      fontSize: 11, cursor: 'pointer',
                    }} title={`Rythme de paiement de ${t.nom}`}>
                      {t.rythme_paiement === 'annuel' ? 'Annuel' : 'Mensuel'}
                    </button>
                    {/* ⚠️ SELECTEUR A TROIS ETATS, pas un bouton a bascule.
                        `actif | essai | suspendu` existent en base (CHECK) ;
                        l'ecran doit offrir les trois, sinon `essai` reste un
                        etat sans chemin. La resiliation est un AUTRE acte :
                        elle n'a pas sa place ici. */}
                    <select className="gss-input" aria-label={`Statut de ${t.nom}`}
                      value={t.abo_statut || 'actif'}
                      onChange={(e) => changerStatut(t, e.target.value)}
                      style={{
                        padding: '4px 8px', borderRadius: 6, fontSize: 11, height: 28,
                        border: '1px solid var(--gss-border-strong)', background: 'transparent',
                        color: STATUT_COLORS[t.abo_statut] || 'var(--gss-text)', cursor: 'pointer',
                      }}>
                      <option value="actif">Actif</option>
                      <option value="essai">Essai</option>
                      <option value="suspendu">Suspendu</option>
                    </select>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        {loading && <p style={{ color: 'var(--gss-text-light)', padding: 20 }}>Chargement...</p>}
        {!loading && tenants.length === 0 && <p style={{ color: 'var(--gss-text-light)', padding: 20 }}>Aucun tenant</p>}
      </div>

      {/* Modal nouveau tenant */}
      {showModal && (
        <div style={S.overlay} onClick={() => setShowModal(false)}>
          <form onSubmit={submit} style={{ ...S.modal, maxHeight: '90vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--gss-text)', marginBottom: 20, flexShrink: 0 }}>Nouveau tenant</div>

            <div style={{ overflowY: 'auto', flex: 1, minHeight: 0, paddingRight: 4 }}>
              <Field label="Nom societe (usage) *" value={form.nom} onChange={v => setForm({ ...form, nom: v })} required />
              <Field label="Raison sociale (denomination legale) *" value={form.raison_sociale}
                     onChange={v => setForm({ ...form, raison_sociale: v })} required
                     placeholder="Celle qui figurera sur les contrats, devis et factures" />
              <Field label="Email admin *" type="email" value={form.email_admin} onChange={v => setForm({ ...form, email_admin: v })} required />
              <Field label="Nom dirigeant" value={form.dirigeant} onChange={v => setForm({ ...form, dirigeant: v })} />

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Field label="RCCM" value={form.rccm} onChange={v => setForm({ ...form, rccm: v })} />
                <Field label="NIF" value={form.nif} onChange={v => setForm({ ...form, nif: v })} />
              </div>

              <Field label="Rue / voie" value={form.adresse} onChange={v => setForm({ ...form, adresse: v })}
                     placeholder="Quartier, rue, immeuble — SANS la ville ni le pays" />
              {erreurRue(form.adresse, form.ville, form.pays) && (
                <div style={S.erreurChamp}>{erreurRue(form.adresse, form.ville, form.pays)}</div>
              )}

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Field label="Ville" value={form.ville} onChange={v => setForm({ ...form, ville: v })} />
                <div style={{ marginBottom: 16 }}>
                  <label style={S.label}>Pays</label>
                  <select value={form.pays} onChange={e => setForm({ ...form, pays: e.target.value })} style={S.input}>
                    {paysListe.length === 0 && <option value="">Referentiel pays indisponible</option>}
                    {paysListe.map(p => (
                      <option key={p.pays_code} value={p.libelle}>
                        {p.libelle}{p.etat === 'vide' ? ' — non parametre' : ''}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <Field label="Telephone" value={form.telephone} onChange={v => setForm({ ...form, telephone: v })} />

              <Field label="Prefixe de matricule (2-5 lettres) *" value={form.prefixe_matricule} onChange={v => setForm({ ...form, prefixe_matricule: v.toUpperCase().replace(/[^A-Z]/g, '').substring(0, 5) })} placeholder="Initiales de la societe" />

              <div style={{ marginBottom: 16 }}>
                <label style={S.label}>Offre</label>
                {/* ⚠️ LES OFFRES VIENNENT DE LA GRILLE, plus d'une liste en dur.
                    Les trois montants ecrits ici (3 500 / 3 000 / 2 500) ne
                    correspondaient a AUCUNE ligne de la grille : l'ecran promettait
                    un prix que la facturation n'appliquait pas. */}
                <select value={form.offre} onChange={e => setForm({ ...form, offre: e.target.value })} style={S.input}>
                  {offres.length === 0 && <option value="">Grille tarifaire indisponible</option>}
                  {offres.map(o => (
                    <option key={o.code} value={o.code} disabled={o.sur_devis}>
                      {o.label}{o.sur_devis
                        ? ' — sur devis, non selectionnable'
                        : ` — ${Number(o.montant).toLocaleString()} F/agent, minimum ${Number(o.montant_plancher).toLocaleString()} F`}
                    </option>
                  ))}
                </select>
                {offres.length === 0 && (
                  <div style={{ fontSize: 12, color: 'var(--gss-danger)', marginTop: 6 }}>
                    Aucune offre lisible dans la grille tarifaire. Aucun tarif par defaut n'existe :
                    renseigner la grille avant de creer un client.
                  </div>
                )}
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={S.label}>Modules optionnels</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginTop: 8 }}>
                  {MODULES_LIST.map(m => (
                    <Check key={m.code} label={m.label} checked={form.modules.includes(m.code)}
                      onChange={() => toggleModule(form.modules, mods => setForm({ ...form, modules: mods }), m.code)} />
                  ))}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', flexShrink: 0, paddingTop: 16, borderTop: '1px solid var(--gss-border-strong)' }}>
              <button type="button" onClick={() => setShowModal(false)} style={{ ...S.btn, background: 'transparent', border: '1px solid var(--gss-border-strong)', color: 'var(--gss-text-light)' }}>Annuler</button>
              {/* ⚠️ LE MESSAGE PORTE SA SORTIE. Une erreur qui nomme un ecran sans
                  y conduire oblige l'utilisateur a le chercher lui-meme. */}
              {erreurCreation && (
                <div style={{ background: 'rgba(239,68,68,0.10)', border: '1px solid var(--gss-danger)',
                  borderRadius: 8, padding: '10px 12px', marginBottom: 12, fontSize: 13 }}>
                  <div style={{ color: 'var(--gss-danger)', fontWeight: 600 }}>{erreurCreation.message}</div>
                  {erreurCreation.pays_disponibles.length > 0 && (
                    <div style={{ marginTop: 6, fontSize: 12, color: 'var(--gss-text-light)' }}>
                      {/* ⚠️ CE SONT DES OBJETS { pays_code, libelle }, pas des chaines.
                          Un `join()` direct aurait affiche « [object Object] » —
                          mesure de la reponse reelle, pas supposition sur sa forme. */}
                      Pays deja parametres : <strong>
                        {erreurCreation.pays_disponibles
                          .map(p => (typeof p === 'string' ? p : `${p.libelle} (${p.pays_code})`))
                          .join(', ')}
                      </strong>
                    </div>
                  )}
                  {erreurCreation.lien && (
                    <Link to={erreurCreation.lien} onClick={() => setShowModal(false)}
                      style={{ display: 'inline-block', marginTop: 8, padding: '6px 12px', borderRadius: 6,
                        background: 'var(--gss-red)', color: '#FFF', fontWeight: 700, fontSize: 12,
                        textDecoration: 'none' }}>
                      Ouvrir le referentiel pays
                    </Link>
                  )}
                </div>
              )}
              <button type="submit" style={S.btn}
                      disabled={!!erreurRue(form.adresse, form.ville, form.pays)}>Creer le tenant</button>
            </div>
          </form>
        </div>
      )}

      {/* Panel fiche tenant (edition) */}
      {editId && editForm && (
        <div style={S.overlay} onClick={() => { setEditId(null); setEditForm(null); }}>
          <div style={{ ...S.modal, maxHeight: '90vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--gss-text)', marginBottom: 20, flexShrink: 0 }}>Fiche tenant</div>

            <div style={{ overflowY: 'auto', flex: 1, minHeight: 0, paddingRight: 4 }}>
              {/* — Identite legale — */}
              <div style={S.sectionLabel}>Identite legale</div>
              <Field label="Nom societe (usage)" value={editForm.nom} onChange={v => setEditForm({ ...editForm, nom: v })} />
              <Field label="Raison sociale (denomination legale) *" value={editForm.raison_sociale}
                     onChange={v => setEditForm({ ...editForm, raison_sociale: v })}
                     placeholder="Portee par les contrats, devis et factures" />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Field label="Forme juridique" value={editForm.forme_juridique} onChange={v => setEditForm({ ...editForm, forme_juridique: v })} placeholder="SARL, SA, SAS..." />
                <Field label="Capital social" value={editForm.capital_social} onChange={v => setEditForm({ ...editForm, capital_social: v })} />
              </div>
              <Field label="Nom dirigeant" value={editForm.dirigeant} onChange={v => setEditForm({ ...editForm, dirigeant: v })} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Field label="RCCM" value={editForm.rccm} onChange={v => setEditForm({ ...editForm, rccm: v })} />
                <Field label="NIF" value={editForm.nif} onChange={v => setEditForm({ ...editForm, nif: v })} />
              </div>
              <Field label="CNSS" value={editForm.cnss} onChange={v => setEditForm({ ...editForm, cnss: v })} />
              <Field label="Agrement securite privee" value={editForm.agrement_securite}
                     onChange={v => setEditForm({ ...editForm, agrement_securite: v })}
                     placeholder="N° d'agrement delivre par l'autorite du pays" />
              {/* Regime fiscal : ecrit dans config.regime_fiscal, EXACTEMENT la ou
                  le generateur de devis le lit (pdf-cover-page.js). */}
              <Field label="Regime fiscal (mention portee sur les devis)" value={editForm.regime_fiscal}
                     onChange={v => setEditForm({ ...editForm, regime_fiscal: v })}
                     placeholder="Ex. : Montants exprimes en HT — TVA en sus selon le regime applicable" />

              {/* — Contact — */}
              <div style={S.sectionLabel}>Contact</div>
              <Field label="Rue / voie" value={editForm.adresse} onChange={v => setEditForm({ ...editForm, adresse: v })}
                     placeholder="Quartier, rue, immeuble — SANS la ville ni le pays" />
              {erreurRue(editForm.adresse, editForm.ville, editForm.pays) && (
                <div style={S.erreurChamp}>{erreurRue(editForm.adresse, editForm.ville, editForm.pays)}</div>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Field label="Ville" value={editForm.ville} onChange={v => setEditForm({ ...editForm, ville: v })} />
                <div style={{ marginBottom: 16 }}>
                  <label style={S.label}>Pays</label>
                  <select value={editForm.pays} onChange={e => setEditForm({ ...editForm, pays: e.target.value })} style={S.input}>
                    {paysListe.length === 0 && <option value="">Referentiel pays indisponible</option>}
                    {paysListe.map(p => (
                      <option key={p.pays_code} value={p.libelle}>
                        {p.libelle}{p.etat === 'vide' ? ' — non parametre' : ''}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <Field label="Telephone" value={editForm.telephone} onChange={v => setEditForm({ ...editForm, telephone: v })} />
              <Field label="Email societe" value={editForm.email_societe} onChange={v => setEditForm({ ...editForm, email_societe: v })} type="email" />

              {/* — Affichage — */}
              <div style={S.sectionLabel}>Affichage</div>
              <Field label="Secteur d'activite" value={editForm.secteur} onChange={v => setEditForm({ ...editForm, secteur: v })} placeholder="Securite privee, Gardiennage..." />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Field label="Prefixe de matricule (2-5 lettres) *" value={editForm.prefixe_matricule} onChange={v => setEditForm({ ...editForm, prefixe_matricule: v.toUpperCase().replace(/[^A-Z]/g, '').substring(0, 5) })} />
                <div style={{ marginBottom: 16 }}>
                  <label style={S.label}>Niveau support</label>
                  <select value={editForm.niveau_support} onChange={e => setEditForm({ ...editForm, niveau_support: e.target.value })} style={S.input}>
                    <option value="standard">Standard (inclus)</option>
                    <option value="business">Business (+50 000 F/mois)</option>
                    <option value="premium">Premium (+100 000 F/mois)</option>
                  </select>
                </div>
              </div>

              {/* — Comptes utilisateurs — */}
              <div style={S.sectionLabel}>Comptes utilisateurs du tenant</div>
              {editComptes.length === 0 ? (
                <div style={S.blocAucunCompte}>
                  <div style={{ fontWeight: 800, marginBottom: 4 }}>
                    Aucun compte utilisateur — ce tenant n'est pas accessible.
                  </div>
                  <div>Personne ne peut se connecter a cet espace. Creer un administrateur
                       rattache a ce tenant pour le rendre accessible.</div>
                </div>
              ) : (
                <div style={{ marginBottom: 20, overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead>
                      <tr>
                        {['Email', 'Role', 'Statut', 'Derniere connexion'].map(h => (
                          <th key={h} style={S.thCompte}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {editComptes.map(c => (
                        <tr key={c.email}>
                          <td style={S.tdCompte}>{c.email}</td>
                          <td style={S.tdCompte}>{c.roles || '(aucun role)'}</td>
                          <td style={{ ...S.tdCompte, fontWeight: 700,
                            color: c.actif ? 'var(--gss-success)' : 'var(--gss-danger)' }}>
                            {c.actif ? 'Actif' : 'Desactive'}
                          </td>
                          {/* « jamais connecte » en toutes lettres : une case vide se
                              lirait comme « connecte, date inconnue ». */}
                          <td style={S.tdCompte}>
                            {c.derniere_connexion
                              ? new Date(c.derniere_connexion).toLocaleDateString('fr-FR')
                              : 'jamais connecte'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div style={{ marginBottom: 20 }}>
                <label style={S.label}>Modules actifs</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginTop: 8 }}>
                  {MODULES_LIST.map(m => (
                    <Check key={m.code} label={m.label} checked={editForm.modules.includes(m.code)}
                      onChange={() => toggleModule(editForm.modules, mods => setEditForm({ ...editForm, modules: mods }), m.code)} />
                  ))}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', flexShrink: 0, paddingTop: 16, borderTop: '1px solid var(--gss-border-strong)' }}>
              <button type="button" onClick={() => { setEditId(null); setEditForm(null); }} style={{ ...S.btn, background: 'transparent', border: '1px solid var(--gss-border-strong)', color: 'var(--gss-text-light)' }}>Fermer</button>
              <button type="button" onClick={saveEdit}
                      disabled={saving || !!erreurRue(editForm.adresse, editForm.ville, editForm.pays)}
                      style={S.btn}>{saving ? 'Enregistrement...' : 'Enregistrer'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════════════════════════════════════════════════════════════
          PANNEAU PAIEMENT ANNUEL
          ═══════════════════════════════════════════════════════════════════
          ⚠️ IL MONTRE LES DEUX MONTANTS COTE A COTE — le socle fige et le
             calcul du jour — parce que c'est leur ECART qui sera appele. Un
             ecran qui n'afficherait que le socle laisserait le super-admin
             renouveler sans savoir ce qu'il change.
          ⚠️ UN REFUS S'AFFICHE COMME UN REFUS, jamais comme un vide : si le
             calcul ne peut pas aboutir (offre sur devis sans tarif negocie,
             module actif non tarife), la phrase du serveur est rendue telle
             quelle. Un montant devine serait pire qu'une absence. */}
      {paiementId && (
        <div style={S.overlay} onClick={() => { setPaiementId(null); setPaiement(null); }}>
          <div style={{ ...S.modal, maxWidth: 620 }} onClick={(e) => e.stopPropagation()}>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--gss-text)', marginBottom: 16 }}>
              Rythme de paiement
            </div>

            {paiementErr && (
              <div style={{ padding: 12, borderRadius: 8, background: 'rgba(239,68,68,0.1)', color: 'var(--gss-danger)', fontSize: 12, marginBottom: 12 }}>
                {paiementErr}
              </div>
            )}
            {!paiement && !paiementErr && (
              <p style={{ fontSize: 12, color: 'var(--gss-text-light)' }}>Lecture en cours...</p>
            )}

            {paiement && (
              <>
                <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--gss-text)', marginBottom: 4 }}>{paiement.tenant}</div>
                {!paiement.facturable && (
                  <div style={{ padding: 10, borderRadius: 8, background: 'rgba(245,158,11,0.12)', color: 'var(--gss-warning)', fontSize: 12, marginBottom: 12 }}>
                    Ce client appartient au groupe de l&apos;éditeur ou sert de démonstration :
                    il ne reçoit aucune facture. Le paiement annuel n&apos;a pas d&apos;objet.
                  </div>
                )}

                <div style={{ padding: 12, background: 'var(--gss-bg)', borderRadius: 8, fontSize: 12, color: 'var(--gss-text-secondary)', marginBottom: 12 }}>
                  <div style={{ marginBottom: 6 }}>
                    Rythme actuel : <strong style={{ color: paiement.rythme_paiement === 'annuel' ? 'var(--gss-success)' : 'var(--gss-text)' }}>
                      {paiement.rythme_paiement === 'annuel' ? 'annuel' : 'mensuel'}
                    </strong>
                  </div>

                  {paiement.socle ? (
                    <>
                      <div>Socle mensuel figé : <strong>{Number(paiement.socle.montant).toLocaleString('fr-FR')} F</strong></div>
                      <div style={{ fontSize: 11, color: 'var(--gss-text-light)', marginTop: 2 }}>
                        {/* La derivation, sans quoi le socle ne se rejoue pas. */}
                        {paiement.socle.effectif} agent(s) × {Number(paiement.socle.tarif_unitaire || 0).toLocaleString('fr-FR')} F
                        {paiement.socle.modules.length > 0 ? ` + modules : ${paiement.socle.modules.join(', ')}` : ' · aucun module'}
                        {paiement.socle.calcule_le ? ` · calculé le ${new Date(paiement.socle.calcule_le).toLocaleDateString('fr-FR')}` : ''}
                      </div>
                      <div style={{ marginTop: 6 }}>
                        Redevance réglée : <strong>{Number(paiement.socle.redevance_reglee).toLocaleString('fr-FR')} F</strong>
                        {' '}({paiement.socle.mois_payes} mois réglés pour {paiement.socle.mois_couverts} mois couverts)
                      </div>
                      {paiement.date_renouvellement && (
                        <div style={{ marginTop: 6, color: paiement.periode_echue ? 'var(--gss-danger)' : 'var(--gss-text-secondary)' }}>
                          Période jusqu&apos;au {new Date(paiement.date_renouvellement).toLocaleDateString('fr-FR')}
                          {paiement.periode_echue ? ' — ÉCHUE, socle à recalculer' : ''}
                        </div>
                      )}
                    </>
                  ) : (
                    <div style={{ color: 'var(--gss-text-light)' }}>Aucun socle : ce client règle chaque mois en entier.</div>
                  )}
                </div>

                <div style={{ padding: 12, background: 'var(--gss-bg)', borderRadius: 8, fontSize: 12, color: 'var(--gss-text-secondary)', marginBottom: 16 }}>
                  {paiement.refus ? (
                    <div style={{ color: 'var(--gss-danger)' }}>{paiement.refus.message}</div>
                  ) : paiement.calcul_du_jour ? (
                    <>
                      <div>Calcul du mois, aujourd&apos;hui : <strong>{Number(paiement.calcul_du_jour.montant).toLocaleString('fr-FR')} F</strong></div>
                      <div style={{ fontSize: 11, color: 'var(--gss-text-light)', marginTop: 2 }}>
                        {paiement.calcul_du_jour.effectif} agent(s) × {Number(paiement.calcul_du_jour.tarif_unitaire).toLocaleString('fr-FR')} F
                        {paiement.calcul_du_jour.modules.length > 0 ? ` + modules : ${paiement.calcul_du_jour.modules.join(', ')}` : ' · aucun module'}
                        {' '}· offre {paiement.calcul_du_jour.offre}
                      </div>
                      {paiement.complement_du_mois !== null && (
                        <div style={{ marginTop: 6 }}>
                          Complément appelé ce mois :{' '}
                          <strong style={{ color: paiement.complement_du_mois > 0 ? 'var(--gss-warning)' : 'var(--gss-success)' }}>
                            {Number(paiement.complement_du_mois).toLocaleString('fr-FR')} F
                          </strong>
                          {paiement.complement_du_mois === 0 ? ' — le socle couvre le mois, aucune pièce émise' : ''}
                        </div>
                      )}
                    </>
                  ) : null}
                </div>

                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <button type="button" onClick={() => { setPaiementId(null); setPaiement(null); }}
                    style={{ ...S.btn, background: 'transparent', border: '1px solid var(--gss-border-strong)', color: 'var(--gss-text-light)' }}>
                    Fermer
                  </button>
                  {paiement.facturable && paiement.rythme_paiement !== 'annuel' && (
                    <button type="button" onClick={() => basculerRythme('annuel')} style={S.btn}>
                      Passer en paiement annuel
                    </button>
                  )}
                  {paiement.rythme_paiement === 'annuel' && paiement.periode_echue && (
                    <button type="button" onClick={renouvelerSocle} style={S.btn}>
                      Renouveler le socle
                    </button>
                  )}
                  {paiement.rythme_paiement === 'annuel' && (
                    <button type="button" onClick={() => basculerRythme('mensuel')}
                      style={{ ...S.btn, background: 'transparent', border: '1px solid var(--gss-border-strong)', color: 'var(--gss-text-light)' }}>
                      Repasser en mensuel
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, value, onChange, type = 'text', required, placeholder }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={S.label}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)}
        required={required} placeholder={placeholder} style={S.input} />
    </div>
  );
}

function Check({ label, checked, onChange }) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--gss-text-secondary)', fontSize: 12, cursor: 'pointer' }}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      {label}
    </label>
  );
}

const S = {
  pastilleAucunCompte: { display: 'inline-block', marginTop: 3, padding: '1px 6px', borderRadius: 4,
    fontSize: 9, fontWeight: 800, letterSpacing: 0.5,
    background: 'var(--gss-red-glow)', color: 'var(--gss-red)' },
  blocAucunCompte: { marginBottom: 20, padding: '10px 12px', borderRadius: 8, fontSize: 12,
    background: '#FFF4E5', border: '1px solid #E8A33D', color: '#7A4B00' },
  thCompte: { textAlign: 'left', padding: '6px 8px', fontSize: 10, textTransform: 'uppercase',
    letterSpacing: 1, color: 'var(--gss-text-light)', borderBottom: '1px solid var(--gss-border)' },
  tdCompte: { padding: '6px 8px', borderBottom: '1px solid var(--gss-border)', color: 'var(--gss-text)' },
  erreurChamp: { marginTop: -10, marginBottom: 14, padding: '6px 10px', borderRadius: 6,
                 background: '#FFF4E5', border: '1px solid #E8A33D', color: '#7A4B00', fontSize: 12 },
  page: { width: '100%', boxSizing: 'border-box', background: 'var(--gss-bg)', padding: 28 },
  card: { background: 'var(--gss-white)', borderRadius: 12, padding: 20, border: '1px solid var(--gss-border)' },
  btn: { padding: '8px 20px', borderRadius: 8, background: 'var(--gss-red)', color: '#FFF', fontWeight: 700, fontSize: 13, border: 'none', cursor: 'pointer' },
  th: { textAlign: 'left', padding: '8px 12px', fontSize: 10, color: 'var(--gss-text-light)', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid var(--gss-border)' },
  td: { padding: '12px', borderBottom: '1px solid var(--gss-border)', fontSize: 13, color: 'var(--gss-text-secondary)' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'var(--gss-white)', borderRadius: 16, padding: 28, width: 500, border: '1px solid var(--gss-border-strong)' },
  sectionLabel: { fontSize: 11, fontWeight: 700, color: 'var(--gss-red)', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 12, marginTop: 4, borderBottom: '1px solid var(--gss-border-strong)', paddingBottom: 6 },
  label: { display: 'block', fontSize: 11, color: 'var(--gss-text-light)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 },
  input: { width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid var(--gss-border-strong)', background: 'var(--gss-bg)', color: 'var(--gss-text)', fontSize: 13, outline: 'none', boxSizing: 'border-box' },
};
